import http from './http'

// let showLoading = false

//导入项目点位
export const getProPointImport = data => {
	return http({ method: 'post', url: `/heating/api/pro/point/import`, data, })
}

//导出项目点位
export const getProPointExport = proCode => {
	return http({ method: 'get', url: `/heating/api/pro/point/export/${proCode}` })
}

//获取项目点位数据列表
export const getProPointDataList = data => {
	return http({ method: 'post', url: `/heating/api/pro/point/data/list`, data, })
}

//获取项目点位表头信息
export const getProPointMeta = proCode => {
	return http({ method: 'get', url: `/heating/api/pro/point/meta/${proCode}` })
}



//总能耗
export const getTotalEnergy = type => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getTotalEnergy/${type}` })
}

//能耗排行
export const getEnergyRanking = type => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getEnergyRanking/${type}` })
}

//项目综合能耗分布
export const getEnergyDistribution = type => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getEnergyDistribution/${type}` })
}

//用水趋势图
export const getWaterTrend = type => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getWaterTrend/${type}` })
}

//用电趋势图
export const getElectricTrend = type => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getElectricTrend/${type}` })
}

//用气趋势图
export const getGasTrend = type => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getGasTrend/${type}` })
}

//费用占比
export const getCostPercent = type => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getCostPercent/${type}` })
}



//所有项目查询
export const getAllProject = () => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getAllProject` })
}

//设备数量
export const getDeviceInfo = projectId => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getDeviceInfo/${projectId}` })
}

//项目下水能耗信息
export const getWaterInfo = code => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getWaterInfo/${code}` })
}

//项目下电能耗信息
export const getElectricInfo = code => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getElectricInfo/${code}` })
}

//项目下燃气能耗信息
export const getGasInfo = code => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getGasInfo/${code}` })
}

//总费用占比
export const getTotleCost = (code, timeType) => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getTotleCost/${code}/${timeType}` })
}

//用水趋势图
export const getWaterTrendByCode = (code, timeType) => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getWaterTrendByCode/${code}/${timeType}` })
}

//用电趋势图
export const getElectricTrendByCode = (code, timeType) => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getElectricTrendByCode/${code}/${timeType}` })
}

//用燃气趋势图
export const getGasTrendByCode = (code, timeType) => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getGasTrendByCode/${code}/${timeType}` })
}

//锅炉燃气用量
export const getProjectBoilerGas = projectId => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getProjectBoilerGas/${projectId}` })
}


//首页地图数据
export const getProjectDetail = () => {
	return http({ method: 'get', url: `/heating/api/druid/projectPointStatisticsData/getProjectDetail` })
}



